// auth modules
import axios from 'axios';
import Router from '../../router'
import {
  CHECK_TAKEN,
  LOGIN_URL,
  ADMIN_LOGIN_URL,
  RESET_EMAIL_URL,
  SEND_VERIFICATION_CODE,
  SIGNUP_URL,
  RESET_PASSWORD,
  CUSTOMER_INFORMATION_URL,
  CHANGE_PASSWORD,
  BALENCE_URL,
} from '../../api/url'

// initial state
const state = {
  loginErrorMessage: '',
  resetEmailMessage: '',
  token: localStorage.getItem('token') || '',
  loggedIn: false,
  userDetails: {},
  
  balance: 0,
  balanceList: [],
  balanceListPaginate: 1,
  balanceListCount: 0,
}

function getHeaderWithToken() {
  const token = localStorage.getItem('token');
  const headers = {
    Authorization: `JWT ${token}`,
  }
  return headers
}

// actions
const actions = {
  LoginRequest: ({commit, dispatch}, data) => {
    commit('updateErrorMessage', null)
    axios({url: LOGIN_URL, data, method: 'POST'})
      .then(res => {
        commit('updateToken', res.data.token);
        commit('updateLoginStatus', true);
        dispatch(`fetchCustomerInformation`, res.data.token);
        localStorage.setItem('token', res.data.token);
        Router.push('/');
      })
      .catch(err => {
        commit('updateErrorMessage', err);
      })
  },
  AdminLoginRequest: ({commit, dispatch}, data) => {
    commit('updateErrorMessage', null)
    axios({url: ADMIN_LOGIN_URL, data, method: 'POST'})
      .then(res => {
        commit('updateToken', res.data.token);
        commit('updateLoginStatus', true);
        dispatch(`fetchCustomerInformation`, res.data.token);
        localStorage.setItem('token', res.data.token);
        Router.push('/');
      })
      .catch(err => {
        commit('updateErrorMessage', err);
      })
  },
  registerRequest: (context, data) => axios({url: SIGNUP_URL, data, method: 'POST'}),
  checkUsername: (context, data) => axios({url: CHECK_TAKEN, data, method: 'POST'}),
  checkEmail: (context, data) => axios({url: CHECK_TAKEN, data, method: 'POST'}),
  resetEmail: (context, data) => axios({url: `${RESET_EMAIL_URL}${data}/`, method: 'POST'}),
  sentVerificationCode: (context, data) => axios({
    url: `${SEND_VERIFICATION_CODE}${data.code}/`,
    data: {token: data.token},
    method: 'POST'
  }),
  resetPassword: (context, data) => axios({url: `${RESET_PASSWORD}`, data, method: 'POST'}),
  changePassword: (context, data) => axios({
    url: `${CHANGE_PASSWORD}`,
    data,
    method: 'POST',
    headers: getHeaderWithToken()
  }),
  fetchCustomerInformation(context, tokken) {
    const token = localStorage.getItem('token') || tokken
    const config = {
      method: 'get',
      url: CUSTOMER_INFORMATION_URL,
      headers: {
        Authorization: `JWT ${token}`,
      }
    };
    axios(config)
      .then((response) => {
        context.commit('fetchCustomerInformation', response.data);
      }, (err) => {
        localStorage.removeItem('token')
        console.log("fetchCustomerInformation error:", err);
      })
  },
  fetchCustomerBalance(context, [id, limit, pages, start_date, end_date, searchValue, searchType, exp]) {
    const token = localStorage.getItem('token');
    
    let start = '';
    let end = '';
    let search = '';
    let ex = '';
    
    if (searchValue && searchType) {
      search = `&${searchType}=${searchValue}`;
    }
    
    if (start_date && end_date) {
      start = `&start_date=${start_date}`;
      end = `&end_date=${end_date}`;
    }
    
    if (exp===true) {
      ex = `&export=${exp}`;
    }

    const config = {
      method: 'get',
      url: `${BALENCE_URL}${id}?limit=${limit}&page=${pages}${start}${end}${search}${ex}`,
      headers: {
        Authorization: `JWT ${token}`,
      }
    }
    axios(config)
    .then(response => {
      context.commit('fetchCustomerBalance', response.data);
    })
    .catch (err => {
      console.log('fetchCustomerBalance', err);
    })
  },
  async postBalance( context, [cardInfo, id]) {
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      url: `${BALENCE_URL}${id}`,
      data: cardInfo,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config) 
    .then((response) => {
    }, (err) => {
      alert('error happen when deposit balance, please contact us.');
    })
  },
};

// mutations
const mutations = {
  updateToken: (state, token) => {
    state.token = token
  },
  updateErrorMessage: (state, message) => {
    if (message) {
      state.loginErrorMessage = "Unable to login with provided credentials"
    } else {
      state.loginErrorMessage = ""
    }
  },
  updateLoginStatus: (state, status) => {
    state.loggedIn = status;
  },
  logout: (state) => {
    state.loggedIn = false;
    state.token = '';
    localStorage.removeItem('token');
    Router.go('/');
  },
  fetchCustomerInformation(state, payload) {
    state.userDetails = payload;
  },
  fetchCustomerBalance(state, payload) {
    if (payload.record.length > 0 ) {
      state.balance = payload.record[0].total_balance;
    }
    state.balanceList = payload.record;
    state.balanceListPaginate = payload.pages;
    state.balanceListCount = payload.count;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js